/**
 * @generated SignedSource<<026c5af2d2aea7ac182ef3508c0f2f40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type instructorsComponent_InstructorsConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"instructorAbout_InstructorFragment">;
    };
  } | null> | null;
  readonly " $fragmentType": "instructorsComponent_InstructorsConnectionFragment";
};
export type instructorsComponent_InstructorsConnectionFragment$key = {
  readonly " $data"?: instructorsComponent_InstructorsConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"instructorsComponent_InstructorsConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "instructorsComponent_InstructorsConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InstructorsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "instructorAbout_InstructorFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InstructorsConnection",
  "abstractKey": null
};

(node as any).hash = "f75185e7a36a782c5140d1e17a2cb387";

export default node;
